module.exports = __webpack_public_path__ + "media/assets/images/flags/cx-07afc2acdfffdb0697c5c6695d9edc81.svg";